import { Button, message } from 'antd';
import React, { useEffect, useState, useImperativeHandle, memo} from 'react';
import useHTTP from '@/hooks/useHTTP.mjs'
import SoftwareMap from "@/components/SoftwareMap/SoftwareMap.jsx";
import Modal from "@/components/Modal/Modal";
import { useStore, useWorkflowStore } from '../store';
import { useCallback } from 'react';

const EventModal = (props) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [mapData, setMapData] = useState({});
  const workflowStore = useWorkflowStore();

  
  const { setBusScenData } = workflowStore.getState();

  const http = useHTTP();

  const handleData = useCallback(async () => {
    http.get(`/dmbds/alg/${props.id}`).then((res) => {
      const { algMap, ...data } = res;
      const newData = {
        ...data,
        bizNodeType: "BDSUMMARY",
        children: JSON.parse(algMap),
      };
      setMapData({
        root: newData,
      });
      showModal();
    })
    .catch((err) => {
      message.error(err.message);
    });
  }, [])

  useEffect(() => {
    handleData()
  }, []);

  const showModal = () => {
      setIsModalOpen(true);
  };

  const handleCancel = () => {
    setBusScenData({id: undefined, name: undefined, type: undefined})
    setIsModalOpen(false);
  };

  return (
      <Modal
        title="用户场景"
        open={isModalOpen}
        width={"70%"}
        bodyStyle={{ height: "calc(78vh - 100px)" }}
        centered
        destroyOnClose
        onCancel={handleCancel}
        footer={[
          <Button key="back" onClick={handleCancel}>
            关闭
          </Button>,
        ]}
      >
        <SoftwareMap mapData={mapData} />
      </Modal>
  )
}

export default memo(EventModal)